import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **CityEndpoint **
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso las relacionadas a los servicios reservables.
 */
export class BookingEndpoint {
  static products = `${apiUrl}products/?marker={}`;
  static booking = `${apiUrl}reservations/{}/`;
  static bookings = `${apiUrl}reservations/data/`;
  static status = `${apiUrl}reservations/get_status/`;
  static productTypeOptions = `${apiUrl}reservations/get_product_type/`;
  static markersOptions = `${apiUrl}reservations/get_markers/?user={}`;
  static variantsBooking = `${apiUrl}products/products_available/`;
  static variantBooking = `${apiUrl}products/{}/`;
  static maxCapacityOptions = `${apiUrl}products/filter_maximum_capacity/?marker={}&type_book_service={}`;
}
